import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getFacilityAssetsById } from '../../Redux/actions';
import { Button, Card, Chip, CircularProgress, Grid, IconButton, Paper, Stack, Table, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import MaintenanceLog from './MaintenanceLog';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { calculateDueDays } from '../../utils';
import BackArrow from '../../Images/BackArrow.png';
import GreenvironmentLogo from '../../../src/Images/GreenvironmentLogo.svg'

export default function ClientAssetDetails() {
    const { client_id, facilityId: id, tabId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [assetShowLoader, setAssetShowLoader] = useState(true)
    const [logsShowLoader, setLogsShowLoader] = useState(true)
    const [assetsData, setAssetsData] = useState([]);

    const clientAssetQueryParams = localStorage.getItem("clientAssetQueryParams");

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setAssetShowLoader(true)
        setLogsShowLoader(true)
        dispatch(getFacilityAssetsById(client_id, id, tabId, {filterInactive: true})).then((res) => {
            if (res && res.status === 200) {
                setAssetShowLoader(false)
                const respData = res?.data?.assetData
                if (!respData) {
                    return;
                }
                setAssetsData(respData)
            }
        })
    }

    const handleDownloadReport = () => {
        window.print()
    }

    let facilityAssetsReport 
    const totalCost = assetsData.reduce((sum, asset) => sum + (parseFloat(asset.cost) || 0), 0);

    if( assetShowLoader ) {
        facilityAssetsReport = (<Grid container style={{ display: 'flex', justifyContent: 'center' }}>
            <Grid item align="center">
                <CircularProgress />
            </Grid>
        </Grid>)
    } else if (!assetsData) {
        facilityAssetsReport = (<Grid container style={{ display: 'flex', justifyContent: 'center',height: '500px',alignItems: 'center' }}>
            <div>
                <h5 className="w3-text-grey">No Data Found</h5>
            </div>
        </Grid>)
    } else {
        
        facilityAssetsReport = (<div className="facility-assets-report-container">
            <Grid style={{ display: 'flex', justifyContent: 'space-between', marginTop:'30px' }}>
                <img id="back-arrow" className="cursor-pointer" width="20px" height="20px" onClick={() => navigate(-1)} src={BackArrow} alt="back-arrow" style={{marginTop: '10px'}} />
                <Button
                    style={{ backgroundColor: '#008080', color: 'white'}}
                    variant="contained"
                    id="download-calibrtaion-report-btn" 
                    onClick={() => handleDownloadReport()}
                    >
                    Download Report
                </Button>
            </Grid>
            <Grid container justifyContent="center" alignItems="center">
                <Grid item>
                    <img alt="green-logo" width="150px" height="100%" src={GreenvironmentLogo} />
                </Grid>
            </Grid>
            <div>
                <TableContainer
                    sx={{
                        mb: 4,
                        mt: 4,
                        border: '1px solid rgba(224, 224, 224, 1)',
                        '@media print': {
                            border: 'none',
                        },
                    }}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ backgroundColor: '#009999', fontSize: '15px', color: 'white' }} className="w3-center" colSpan={12}><b>{`${assetsData[0]?.category} Report`}</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableRow>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)' }} colSpan={8}><b>Facility Name</b></TableCell>
                            <TableCell colSpan={4}>{assetsData[0]?.facility?.facility_name}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)' }} colSpan={8}><b>Location Name</b></TableCell>
                            <TableCell colSpan={4}>{assetsData[0]?.facility?.location?.name}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)' }} colSpan={8}><b>Category</b></TableCell>
                            <TableCell colSpan={4}>{assetsData[0]?.category}</TableCell>
                        </TableRow>
                    </Table>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ backgroundColor: '#009999', fontSize: '15px', color: 'white' }} className="w3-center" colSpan={12}><b>Report Summary</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableRow>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)', backgroundColor: '#009999', fontSize: '15px', color: 'white' }} colSpan={1}><b>Sl No</b></TableCell>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)', backgroundColor: '#009999', fontSize: '15px', color: 'white' }} colSpan={6}><b>Item Name</b></TableCell>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)', backgroundColor: '#009999', fontSize: '15px', color: 'white' }} colSpan={1}><b>Particulars</b></TableCell>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)', backgroundColor: '#009999', fontSize: '15px', color: 'white' }} colSpan={1}><b>Serial Nos</b></TableCell>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)', backgroundColor: '#009999', fontSize: '15px', color: 'white' }} colSpan={1}><b>Installation Date</b></TableCell>
                            <TableCell style={{ borderRight: '1px  solid rgba(224, 224, 224, 1)', backgroundColor: '#009999', fontSize: '15px', color: 'white' }} colSpan={1}><b>Asset Cost</b></TableCell>
                            <TableCell style={{ backgroundColor: '#009999', fontSize: '15px', color: 'white' }} colSpan={4}><b>Photo</b></TableCell>
                        </TableRow>
                        {assetsData?.map((asset, idx) => {
                                return (
                                    <TableRow key={idx}>
                                        <TableCell style={{ width: '10%', borderRight: '1px solid rgba(224, 224, 224, 1)' }} colSpan={1}>{idx + 1}</TableCell>
                                        <TableCell style={{ width: '40%', borderRight: '1px solid rgba(224, 224, 224, 1)' }} colSpan={6}>{asset?.assetName?.asset_name || '--'}</TableCell>
                                        <TableCell style={{ width: '20%', borderRight: '1px solid rgba(224, 224, 224, 1)' }} colSpan={1}>{asset?.particulars}</TableCell>
                                        <TableCell style={{ width: '20%', borderRight: '1px solid rgba(224, 224, 224, 1)' }} colSpan={1}>{asset?.serial_number}</TableCell>
                                        <TableCell style={{ width: '20%', borderRight: '1px solid rgba(224, 224, 224, 1)' }} colSpan={1}>{new Date(asset?.installation_date).toLocaleString(undefined, {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                        })}</TableCell>
                                        <TableCell style={{ width: '20%', borderRight: '1px solid rgba(224, 224, 224, 1)' }} colSpan={1}>{`₹ ${asset?.cost}`}</TableCell>
                                        <TableCell style={{ width: '30%' }} colSpan={4}>
                                            {asset?.assetMedia.map((image, index) => (
                                                <img key={index} style={{paddingRight: '10px', paddingBottom: '10px'}} width="120px" alt={`${idx} pic`} src={image.path} />
                                            ))}
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        }
                        <TableRow>
                            <TableCell colSpan={10} align="right" style={{ fontWeight: 'bold', fontSize: '15px'}}>
                                Total Cost
                            </TableCell>
                            <TableCell colSpan={2} style={{ fontWeight: 'bold', fontSize: '15px'}}>
                                ₹ {totalCost.toLocaleString()}
                            </TableCell>
                        </TableRow>
                    </Table>
                </TableContainer>
            </div>
        </div>
        ) 
    }
    
    return (
        <Grid container>
            {facilityAssetsReport}
            { (((tabId !== 'leased-asset') && (tabId !== 'sale')) && !assetShowLoader) && (<div className='hide-in-print w3-padding'>
                <Grid  container item xs={12} justifyContent="center" sx={{ mt: 4 }}>
                    <h5 style={{ fontWeight: 'bold' }}>MAINTENANCE LOG DETAILS</h5>
                </Grid>

                {assetsData?.map((asset, idx) => (
                    <Grid item xs={12} key={idx}>
                        <Typography
                            fontWeight={600}
                            sx={{
                                mb: 0,
                                mt: 2,
                                ml: 4,
                                color: '#333',
                                fontSize: '15px'
                            }}
                        >
                            {asset?.assetName?.asset_name}
                        </Typography>
                        <MaintenanceLog viewSelectedAssets={asset?.unique_id} />
                    </Grid>
                ))}
            </div>)}
        </Grid>
    );
    
}